export const isDiscountedProduct = (discount, cashback_amount) => {
  if (discount === "0" && !cashback_amount) {
    return {
      productType: "Discount",
      discount: discount,
    };
  } else if (discount == "0" && cashback_amount > 0) {
    return {
      productType: "Cashback",
      discount: cashback_amount,
    };
  } else {
    return {
      productType: "Discount",
      discount: discount,
    };
  }
};

export function sortByKey(data, key, order = "asc") {
  if (!Array.isArray(data)) return null;

  return data.slice().sort((a, b) => {
    let valA = a[key];
    let valB = b[key];

    // Convert to Date if the key is likely a date string
    if (key.toLowerCase().includes("date") || key.includes("created_at")) {
      valA = new Date(valA);
      valB = new Date(valB);
    }

    if (valA < valB) return order === "asc" ? -1 : 1;
    if (valA > valB) return order === "asc" ? 1 : -1;
    return 0;
  });
}

export function extractTitleAndDate(data) {
  if (!Array.isArray(data)) {
    throw new Error("Input must be an array");
  }

  return data.map(({ title, created_at }) => ({
    title,
    created_at,
  }));
}


export async function blogCategoryFilter(data, key, category) {
  if (!Array.isArray(data)) {
    return null;
  }

  if (!key || typeof key !== "string") {
    throw new Error("A valid key must be provided");
  }

  if (typeof category === "undefined" || category === null) {
    return data; // No filtering if category is not defined
  }

  return data.filter((item) => {
    // Make sure the key exists in the item
    if (!(key in item)) return false;

    // Compare by string match (case insensitive)
    return String(item[key]).toLowerCase() === String(category).toLowerCase();
  });
}



export const isValidInputAscii = (str) => {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const isLetter = (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
    const isNumber = code >= 48 && code <= 57;
    const isHyphen = code === 45;

    if (!isLetter && !isNumber && !isHyphen) {
      return false;
    }
  }
  return true;
}

export const isValidInputAsciiWithSpace = (str) => {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const isLetter = (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
    const isNumber = code >= 48 && code <= 57;
    const isHyphen = code === 45;
    const isSpace = code === 32;

    if (!isLetter && !isNumber && !isHyphen && !isSpace) {
      return false;
    }
  }
  return true;
};